import styled from 'styled-components'

import { Logo } from 'components/Logo'

export const BrandLogo = styled(Logo)`
	height: 10px;
	width: 41px;
`
